module.exports = __webpack_public_path__ + "img/上传失败.56de2dab.png";